export default __webpack_public_path__ + "static/gynoveda-logo-3b5249bc48d87c762db760820c33e359.svg";